export default __webpack_public_path__ + "static/media/SecureUserExp.Right.5bd6b93f.png";